// extracted by mini-css-extract-plugin
module.exports = {"card":"card___1zu-u"};